import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {LocalValidators} from '../../../../modules/utils/validators/LocalValidators';
import {Resident, ResidentForSelect, SuiteUser} from '../../../../types/models';
import {ParcelsService} from '../../../../services/parcels.service';
import {finalize, tap} from 'rxjs/operators';

declare const toastr: any;

@Component({
    selector: 'add-resident-email-form',
    templateUrl: './add-resident-email-form.component.html',
    styleUrls: ['./add-resident-email-form.component.scss'],
})
export class AddResidentEmailFormComponent implements OnInit {
    @Input() resident: ResidentForSelect;
    @Input() suiteUser: SuiteUser;
    @HostBinding('attr.class') hostClass = 'm-t-sm m-b-sm user-email-form';
    showAddForm: boolean = false;
    loading: boolean = false;
    form: FormGroup;

    constructor(
        private parcelsService: ParcelsService
    ) {
        this.form = new FormGroup({
            addResidentEmail: new FormControl('', Validators.compose([
                Validators.required,
                LocalValidators.email
            ]))
        });
    }

    ngOnInit() {
    }

    submit() {
        if (this.form.invalid) {
            toastr.error('Invalid Email');
            return;
        }
        this.loading = true;
        this.parcelsService.setResidentEmail(this.suiteUser.id, this.form.value.addResidentEmail)
            .pipe(
                tap((result: Resident) => {
                    this.resident.email = result.email;
                }),
                finalize(() => this.loading = false),
            )
            .subscribe();
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-modal/add-resident-email-form/add-resident-email-form.component.ts